import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService } from '../common/alert.service';

@Injectable()
export class AppErrorHandler implements ErrorHandler {
    private route: Router;
    private zone: NgZone;
    private alertService: AlertService;
    constructor(injector: Injector) {
        setTimeout(() => {
            this.route = injector.get(Router);
            this.zone = injector.get(NgZone);
            this.alertService = injector.get(AlertService);
        });
    }
    handleError(error: any) {
        // tslint:disable-next-line:no-debugger
        this.zone.run(() => {
            // tslint:disable-next-line:no-debugger
            if (error.status === 404) {
                this.route.navigate(['/error/5']);
            } else if (error.status === 401) {
                this.route.navigate(['/error/1']);
            } else if (error.status === 408 || error.status === 406) {
                alert('Your session has been expired.');
                this.route.navigate(['/logout']);
            } else if (error.status <= 0) {
                this.route.navigate(['/error/2']);
            } else if (error.status === 417) {
                this.route.navigate(['/error/4']);
            } else {
                this.route.navigate(['/error/2']);
            }
        }, (httperror) => {
        });
    }
}
